import React, { useState } from 'react'
import {
  Div, H4, Input,
} from 'konsys-ui'
import { theme } from '../../../../../styles/_variables'
import {
  ButtonEdit, InputNumber,
} from './styled'


const { color } = theme

const MinimumCostInput = ({
  data,
  onInputChange,
  action,
}) => {
  const [actionState, setActionState] = useState(action)
  const [minimumOperationCost, setMinimumOperationCost] = useState(data.minimumCost || 0)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='flex-start' alignItems='baseline' moreStyle={{ columnGap: '12px' }}>
        <H4 bold color={color.primaryColor} margin='32px 0'>ต้นทุนขั้นต่ำ</H4>
        {
          actionState === 'create' ? <>
          <InputNumber
            value={data.minimumOperationCost}
            min={0}
            max={9999}
            step="1"
            type='number'
            onChange={(e) => {
              onInputChange({ ...data, minimumOperationCost: Math.round(e * 100) / 100 })
            }}
            onKeyPress={(e) => {
              if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault()
              }
            }}
            style={{ width: '20%' }}
          />
          <H4 bold color={color.primaryColor} margin='32px 0'>บาท</H4>
          </> : actionState === 'detail' ? <>
            <H4 bold color={color.textColor} margin='32px 0px 32px 64px'>{data.minimumOperationCost} บาท</H4>
            <ButtonEdit
              text='แก้ไข'
              icon='fa fa-pencil'
              inverse
              onClick={() => setActionState('edit')}
            />
          </> : actionState === 'edit' ? <>
            <InputNumber
              value={minimumOperationCost}
              min={0}
              max={9999}
              step="1"
              type='number'
              onChange={(e) => {
                setMinimumOperationCost(Math.round(e * 100) / 100)
              }}
              onKeyPress={(e) => {
                if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                  e.preventDefault()
                }
              }}
              style={{ width: '20%' }}
            />
            <H4 bold color={color.primaryColor} margin='32px 0'>บาท</H4>
            <ButtonEdit
              text='ยกเลิก'
              onClick={() => {
                setMinimumOperationCost(data.minimumOperationCost)
                setActionState('detail')
              }}
            />
            <ButtonEdit
              text='ยืนยัน'
              inverse
              onClick={() => {
                onInputChange({ ...data, minimumOperationCost: Math.round(minimumOperationCost * 100) / 100 })
                setActionState('detail')
              }}
            />
          </> : null
        }
      </Div>
    </Div>
  )
}

export default MinimumCostInput
